import React from 'react';
// import homeContainer from '../../component/HomePage/homeContainer';
import secondsToHms from '../../common/SecondsToHms/secondsToHms';
import { connect } from 'react-redux';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import thumb1 from '../../assets/images/thumb1.png';
import thumb2 from '../../assets/images/thumb2.png';
import './sliderStyle.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons'
import Card from '../../common/card/Card';
import Rating from '../Rating/Rating';
import { useHistory } from "react-router-dom";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3.5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3.3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function CarouselBlock(props) {

  const history = useHistory();

  const findSkill = (id) => {
    return props.skills.find((e) => {
      return e.id === id
    })
  }

  const goToCourseDetails = (cid) => {
    history.push({
      pathname: `/course-details`,
      state: {
        cid
      }
    });
  }

  const startUi = (e) => {
    if (e && e.progress > 0) {
      return <button className="btn" type="button" onClick={() => props.playCourse(e.id)}>Continue</button>
    } else if (e && e.progress === 100) {
      return <button className="btn" type="button" onClick={() => props.playCourse(e.id)}>Revisit</button>
    } else {
      return <button className="btn" type="button" onClick={() => props.playCourse(e.id)}>Start</button>
    }
  }

  return (
    <React.Fragment>
      <Carousel responsive={responsive}>
        {(props.myLearningObj) ? (props.myLearningObj).map((e, i) =>
          <div className='card-block' key={i}>
            <div className='card-img-block cp'>
              <img src={e.imageUrl} alt='...' onClick={() => goToCourseDetails(e.id)} />
              <span>{e.loFormat}</span>
            </div>
            <div className='card-content'>
              <div className='card-title cp' onClick={() => goToCourseDetails(e.id)}>
                <span>{e.loName}</span>
              </div>
              <span className='time-recent'>{findSkill(e.skill).name}
                <span>
                  {/* {e.duration > 0 && */}
                  <React.Fragment>
                    <span className="small-separator" style={{ visibility: e.duration != 0 ? 'visible' : 'hidden' }}></span>
                    <span style={{ visibility: e.duration != 0 ? 'visible' : 'hidden' }}>{secondsToHms(e.duration)}</span>
                  </React.Fragment>
                  {/* } */}
                </span>
              </span>
              <div className='card-button'>
                {startUi(e)}
              </div>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{ width: `${e.progress}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                {(e.loCategory !== "recommendation") &&
                  <span style={{ left: `${e.progress > 92 ? '92' : e.progress}%` }}>{e.progress}%</span>
                }
              </div>
            </div>
          </div>
        ) : <div></div>}
      </Carousel>
      <Carousel responsive={responsive}>
        {(props.myRecLearningObj) ? (props.myRecLearningObj).map((e, i) =>
          // <div className='card-block'>
          //   <div className='card-img-block'>
          //     <img src={e.imageUrl} alt='...' />
          //     <span>{e.loType}</span>
          //   </div>
          //   <div className='card-content'>
          //     <div className='card-title'>
          //       <span>{e.loName}</span>
          //     </div>
          //     <div className='card-button'>
          //       <span className=''>{findSkill(e.skill).name} | {secondsToHms(e.duration)}</span>
          //       <span className='star'>                  
          //       {new Array(Math.round(e.rating)).fill(null).map(() => (
          //         <FontAwesomeIcon style={{ color: "#FEC030" }} icon={faStar} />
          //       ))}
          //       {new Array(5 - Math.round(e.rating)).fill(null).map(() => (
          //         <FontAwesomeIcon icon={faStar} />
          //       ))}
          //       </span>
          //       <span>{startUi(e)}</span>
          //     </div>
          //   </div>
          // </div>

          <div className='card-block' key={i}>
            <div className='card-img-block cp' >
              <img src={e.imageUrl} alt='Loading' onClick={() => goToCourseDetails(e.id)} />
              <span>{e.loType}</span>
            </div>
            <div className='card-content'>
              <div className='card-title cp' onClick={() => goToCourseDetails(e.id)}>
                {e.loName}
              </div>
              <div className='time-recent' >
                <span className='skill-block'>{findSkill(e.skill).name}</span>
                {/* {e.duration > 0 && */}
                <span style={{ visibility: e.duration != 0 ? 'visible' : 'hidden' }}>
                  <span className='small-separator'>
                  </span>
                  <span>{secondsToHms(e.duration)}</span>
                </span>
                {/* } */}

              </div>
              <div className='card-button'>
                <span className='star' >
                  <Rating number={e.rating}></Rating>
                </span>
                {!e.enrollment ?
                  <button className='btn' onClick={() => props.enrollToCourse(e.id, e.instancesId)}>Enroll</button> :
                  startUi(e)
                }

              </div>
            </div>
          </div>

        ) : <div></div>}
      </Carousel>
    </React.Fragment>
  );
}

const mapStateToProps = state => {
  return {
    skills: state.skills
  }
}
export default connect(mapStateToProps)(CarouselBlock);   